

angular
.module('inkfinder')
.factory('CheckHoursCollisions', function CheckHoursCollisions(
  $q,
  ShopHours,
  moment
) {
  // Public methods
  CheckHoursCollisions.check = check;

  /**
   * @name check
   * @description description
   * @param {type} data Description
   * @param {type} appointments Description
   * @param {type} artist Description
   * @param {type} selected_date Description
   * @return {type} Description
   */
  function check(data, appointments, artist, selected_date) {
    return $q(function(resolve, reject) {
      let shop_hours = ShopHours.getHoursByDay(selected_date);
      let errors = [];
      let warnings = [];

      let base_date_string =
      moment(selected_date).format('YYYY-MM-DD');

      let shop_start = moment(base_date_string + ' ' +
      shop_hours.start_time, 'YYYY-MM-DD HH:mm:ss');
      let shop_end = moment(base_date_string + ' ' +
      shop_hours.end_time, 'YYYY-MM-DD HH:mm:ss');

      // Date Correction
      if (shop_end < shop_start) {
        shop_end = shop_end.add(1, 'day');
      }

      let start_time_string =
      moment(data.temp.raw_start_time).format('HH:mm:ss');
      let end_time_string =
      moment(data.temp.raw_end_time).format('HH:mm:ss');

      let start_time = moment(base_date_string + ' ' +
      start_time_string, 'YYYY-MM-DD HH:mm:ss');
      let end_time = moment(base_date_string + ' ' +
      end_time_string, 'YYYY-MM-DD HH:mm:ss');

      if (parseInt(end_time.unix(), 10) === parseInt(start_time.unix(), 10)) {
        errors.push('Start and end time cannot be the same.');
      }

      // Date Correction
      if (end_time < start_time) {
        end_time.add(1, 'day');
      }

      // If the Requested Start time is less than the Shop Start && the End Time is greater than the Shop End
      if (start_time < shop_start || end_time > shop_end) {
        errors.push('This time is outside of shop hours. This schedule can’t be saved.');
      }

      if (errors.length) {
        reject({
          errors: errors,
          warnings: warnings
        });
      } else {
        resolve({
          warnings: warnings
        });
      }
    });
  }
  return CheckHoursCollisions;
});



// WEBPACK FOOTER //
// ./components/schedule/util/check-hours-collision.service.js